const navConfig = [
  {
    linkTo: 'home',
    defaultTitle: 'Home',
    titleKey: 'nav-menu.home',
  },
  {
    linkTo: 'about',
    defaultTitle: 'About',
    titleKey: 'nav-menu.about',
  },
  {
    linkTo: 'services',
    defaultTitle: 'Services',
    titleKey: 'nav-menu.services',
  },
  {
    linkTo: 'contact',
    defaultTitle: 'Contacts',
    titleKey: 'nav-menu.contact',
  },
];

const feedConfig = [
  {
    href: 'http://www.facebook.com/',
    text: 'Facebook',
    className: 'fab fa-facebook-f',
  },
  {
    href: 'http://www.twitter.com/',
    text: 'Twitter',
    className: 'fab fa-twitter',
  },
  {
    href: 'http://www.github.com/',
    text: 'Github',
    className: 'fab fa-github',
  },
  {
    href: 'http://www.google.com/',
    text: 'Google',
    className: 'fab fa-google',
  },
];

export { navConfig, feedConfig };
